/* eslint-disable no-param-reassign */
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { connect } from "react-redux";
import "./GcLedger.css";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import moment from "moment";
import { indianNSConverter } from "../../../shared/methods/indianNSConverter";

function GcLeadger({ details, closeEditModal }) {
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open
      className="gcDialogWrapper"
      onClose={closeEditModal}
    >
      <DialogContent className="dialog-content">
        <div className="main-wrapper">
          <div className="titleContainer">
            <div className="dialogTitle">GC adjusted</div>
            <IconButton onClick={closeEditModal} style={{ padding: 0, color: "#323232" }}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className="ledgerContainer">
            <div className="tableHeader">
              <div className="tableHeaderValue">Original date</div>
              <div className="tableHeaderValue">Adjusted amount</div>
            </div>
            <hr className="horizontalLine" />
            {details.gcEditLedger?.length > 0 ? (
              details.gcEditLedger.map((item, idx) => (
                <div key={idx} className="tableRow">
                  <div className="tableRowValue">
                    <div>
                      {moment(item.date).format("DD MMM YYYY")}
                    </div>
                    <div>
                      ₹
                      {indianNSConverter(item.value)}
                    </div>
                  </div>
                  <hr className="horizontalLine" />
                </div>
              ))
            ) : (
              null
            )}
            <div className="tableHeader">
              <div className="tableHeaderValue">Total amount</div>
              <div className="tableHeaderValue">
                ₹
                {indianNSConverter(details?.totalGcEdit)}
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default connect(null, null)(GcLeadger);
